<!--
    Program: common error page
    Author: SDL
    Brief: common error page
-->
<template>
<div id="wrap" class="full_wrap"><!-- GNB/Footer 없을때 -->
    <!-- container -->
    <div id="container">
        <div class="container_wrap">

            <div class="msg_item">
                <p>
                    <em>The connection is delayed. Please try again later.</em>
                    <a v-show="isLogin" href="javascript:" class="btn_blue" @click="goMain">Click</a>
                </p>
            </div>

        </div>
    </div>
    <!-- //container -->
</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import _                        from 'lodash';
import store                    from '@/vuex/store';
import { SDLUtil, MenuUtil }    from '@/utils';

export default {
    data() {
        return {

        };
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            loginSystem: 'getLoginSystem',
            storeParams: 'getParams'
        }),
        isLogin() {
            return SDLUtil.isLogin();
        },
        getLoginUser() {
            return SDLUtil.getLoginedUserInfo();
        },
    },
    methods: {
        goMain() {
            store.commit( 'PARAMS', Object.assign( this.storeParams, { menuId : '', menuGrpCd : '', menuGrpDetailCd : '', creationYn : null } ) );
            if(this.loginSystem == 'SUPPORT') {
                this.$router.push(MenuUtil.getSupportMain());
            } else {
                this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/` });
            }
        }
    },
    mounted() {

    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/common/ErrorPage.vue